<template>
  <div>
    <slot>
      <div class="bg-light-gray-700 h-52 w-full"></div>
    </slot>
  </div>

</template>

<script>
import { computed } from '@vue/runtime-core';

export default {

	props: {
	},

  setup(props) {
  }

}
</script>

<style>

</style>